import client from 'core/axios';
import handleError from 'core/axios/handleError';
import { handleJSONResponse } from 'core/axios/handleResponse';
import RequestMethod from 'core/axios/RequestMethod';

export const getStudentProfile = ({ userId, version = 'v1' } = {}) =>
  client
    .request({
      url: userId
        ? `${version}/student-profile/profile/${userId}/`
        : `${version}/student-profile/profile/`,
      method: RequestMethod.GET,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getStudentContactInfo = ({
  userId,
  version = 'v1',
  params,
} = {}) =>
  client
    .request({
      url: `${version}/student-profile/user-contact-info/${userId}/`,
      method: RequestMethod.GET,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const updateStudentContactInfo = ({
  userId,
  version = 'v1',
  payload,
} = {}) =>
  client
    .request({
      url: `${version}/student-profile/user-contact-info/${userId}/`,
      method: RequestMethod.PATCH,
      data: payload,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const updateStudentProfile = ({ payload, version = 'v1' } = {}) =>
  client
    .request({
      url: `${version}/student-profile/update/`,
      method: RequestMethod.PATCH,
      data: payload,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const generateResume = ({ payload, version = 'v1' } = {}) =>
  client
    .request({
      url: `${version}/student-profile/resume-export/`,
      method: RequestMethod.POST,
      data: payload,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const createProfileVideo = ({ payload, version = 'v1' } = {}) =>
  client
    .request({
      url: `${version}/student-profile/profile-videos/`,
      method: RequestMethod.POST,
      data: payload,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const deleteProfileVideo = ({ videoId, version = 'v1' } = {}) =>
  client
    .request({
      url: `${version}/student-profile/profile-videos/${videoId}/`,
      method: RequestMethod.DELETE,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getProfileVideoQuestions = ({ version = 'v1' } = {}) =>
  client
    .request({
      url: `${version}/student-profile/profile-video-questions/`,
      method: RequestMethod.GET,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const createProfileVideoQuestion = ({ payload, version = 'v1' } = {}) =>
  client
    .request({
      url: `${version}/student-profile/profile-video-questions/`,
      method: RequestMethod.POST,
      data: payload,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const deleteProfileVideoQuestion = ({
  questionId,
  version = 'v1',
} = {}) =>
  client
    .request({
      url: `${version}/student-profile/profile-video-questions/${questionId}/`,
      method: RequestMethod.DELETE,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const updateScoresVisibility = async ({
  visibleSatScores,
  visibleActScores,
  visibleApScores,
}) =>
  client
    .put(`v1/test-scores/visibility/`, {
      visibleSatScores,
      visibleActScores,
      visibleApScores,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const createProfileReference = ({ payload, version = 'v1' } = {}) =>
  client
    .request({
      url: `${version}/student-profile/profile-reference/`,
      method: RequestMethod.POST,
      data: payload,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const updateProfileReference = ({
  referenceUuid,
  payload,
  version = 'v1',
} = {}) =>
  client
    .request({
      url: `${version}/student-profile/profile-reference/${referenceUuid}`,
      method: RequestMethod.PATCH,
      data: payload,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const deleteProfileReference = ({
  referenceUuid,
  version = 'v1',
} = {}) =>
  client
    .request({
      url: `${version}/student-profile/profile-reference/${referenceUuid}`,
      method: RequestMethod.DELETE,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getStudentUserId = ({ version = 'v1', params = {} } = {}) =>
  client
    .request({
      url: `${version}/sl_users/user-info/`,
      method: RequestMethod.GET,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);
